'use client';

import { Bars3Icon } from '@heroicons/react/16/solid';
import type { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd';

interface DragHandleProps {
  readonly dragHandleProps: DraggableProvidedDragHandleProps | null | undefined;
}

export const DragHandle = ({ dragHandleProps }: DragHandleProps) => {
  if (!dragHandleProps) return null;

  return (
    <div
      aria-label='Dra för att flytta'
      title='Dra för att flytta'
      {...dragHandleProps}
      className='flex shrink-0 cursor-grab items-center bg-muted-foreground/10 px-2'
      role='button'
    >
      <Bars3Icon className='size-4' />
    </div>
  );
};
